var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreehandArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.75 11.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#010201;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#010201;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,12.47a5.82,5.82,0,0,1,7.69.54c3.11,3.06,2.58,9.63,11,6.06",
    transform: "translate(-5.96 -10.23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.53,15.85l7.08.31a.15.15,0,0,1,.09.18l-4.37,5.72a.14.14,0,0,1-.26,0l-2.72-6A.15.15,0,0,1,24.53,15.85Z",
    transform: "translate(-5.96 -10.23)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreehandArrow);
export default __webpack_public_path__ + "static/media/freehand_arrow.fccee97d.svg";
export { ForwardRef as ReactComponent };